// import React, { useState } from "react";
// import styled, { keyframes, createGlobalStyle } from "styled-components";
// import { Link, useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const RegistrationForm = () => {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const validatePassword = (password) => {
//     // Regex for strong password
//     const strongPasswordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     return strongPasswordRegex.test(password);
//   };

//   const handleRegister = async (e) => {
//     e.preventDefault();

//     if (!validatePassword(password)) {
//       toast.error(
//         "❌ Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
//       );
//       return;
//     }

//     const registrationData = { name, email, password };

//     try {
//       const response = await fetch("http://localhost:5000/api/register", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(registrationData),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         toast.success("✅ Registration successful!");
//         navigate("/Login");
//       } else {
//         toast.error(`❌ Registration failed: ${result.error}`);
//       }
//     } catch (err) {
//       console.error("Error during registration:", err);
//       toast.error("❌ Something went wrong. Please try again later.");
//     }
//   };

//   return (
//     <Container>
//       <h2>Register</h2>
//       <form onSubmit={handleRegister}>
//         <Label>Name</Label>
//         <Input
//           type="text"
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           required
//         />
//         <Label>Email</Label>
//         <Input
//           type="email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />
//         <Label>Password</Label>
//         <Input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />
//         <Button type="submit">Register</Button>
//       </form>

//       {/* Toast container inside the box */}
//       <ToastContainer
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={true}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss={false}
//         draggable={false}
//         pauseOnHover={false}
//         style={{ width: "100%", boxSizing: "border-box" }}
//         toastClassName="custom-toast"
//         bodyClassName="custom-toast-body"
//       />

//       <Footer>
//         Already registered? <Link to="/login">Login</Link>
//       </Footer>
//     </Container>
//   );
// };

// export default RegistrationForm;

// // Global styles for toast notifications (simple alert style)
// const GlobalToastStyles = createGlobalStyle`
//   .custom-toast {
//     background: #323232 !important;
//     color: #fff !important;
//     border-radius: 4px !important;
//     box-shadow: none !important;
//     font-weight: 600 !important;
//     font-size: 1rem !important;
//     width: 100% !important;
//     margin: 0 !important;
//     padding: 10px 15px !important;
//     border: 1px solid #444 !important;
//     text-align: center !important;
//   }
//   .custom-toast-body {
//     margin: 0 !important;
//     padding: 0 !important;
//   }
// `;

// // Add this at the root or inside your app (e.g. App.js)
// // <GlobalToastStyles />

// // Animation and styled components (unchanged)...

// const fadeIn = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(20px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const Container = styled.div`
//   max-width: 500px;
//   margin: 4rem auto;
//   padding: 2rem;
//   background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
//   border-radius: 8px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
//   border: 1px solid #1f1f21;
//   animation: ${fadeIn} 0.5s ease;

//   h2 {
//     color: #e6e6e6;
//     margin-bottom: 1.5rem;
//     text-align: center;
//   }
// `;

// const Label = styled.label`
//   display: block;
//   font-size: 1.1rem;
//   margin-bottom: 0.5rem;
//   color: #e6e6e6;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 0.75rem;
//   margin-bottom: 1rem;
//   border: 1px solid #1f1f21;
//   background-color: transparent;
//   color: #e6e6e6;
//   border-radius: 4px;
//   text-transform: none;

//   &:focus {
//     border-color: #3f51ff;
//     outline: none;
//   }
// `;

// const Button = styled.button`
//   background: linear-gradient(90deg, #194bfd 0%, #ad13fb 100%);
//   color: #ffffff;
//   transition: all 0.3s ease;
//   padding: 0.75rem 1.5rem;
//   border: none;
//   margin-top: 1rem;
//   border-radius: 4px;
//   cursor: pointer;
//   width: 100%;
//   font-weight: bold;

//   &:hover {
//     background-color: #5a189a;
//     color: #ffffff;
//     transform: translateY(-2px);
//     box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
//   }
// `;

// const Footer = styled.div`
//   text-align: center;
//   margin-top: 1.5rem;
//   color: #aaa;

//   a {
//     color: #4e9eff;
//     text-decoration: none;
//     font-weight: bold;

//     &:hover {
//       text-decoration: underline;
//     }
//   }
// `;

import React, { useState } from "react";
import styled, { keyframes, createGlobalStyle } from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RegistrationForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const validatePassword = (password) => {
    // Strong password regex: min 8 chars, uppercase, lowercase, digit, special char
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return strongPasswordRegex.test(password);
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!validatePassword(password)) {
      toast.error(
        "❌ Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
      );
      return;
    }

    const registrationData = { name, email, password };

    try {
      const response = await fetch("http://localhost:5000/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(registrationData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("✅ Registration successful!");
        navigate("/login");
      } else {
        toast.error(
          `❌ Registration failed: ${result.error || "Unknown error"}`
        );
      }
    } catch (err) {
      console.error("Error during registration:", err);
      toast.error("❌ Something went wrong. Please try again later.");
    }
  };

  return (
    <Container>
      <GlobalToastStyles />
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          placeholder="At least 8 chars, uppercase, lowercase, number, special char"
        />
        <Button type="submit">Register</Button>
      </form>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        style={{ width: "100%", boxSizing: "border-box" }}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />

      <Footer>
        Already registered? <Link to="/login">Login</Link>
      </Footer>
    </Container>
  );
};

export default RegistrationForm;

// Global styles for toast notifications
const GlobalToastStyles = createGlobalStyle`
  .custom-toast {
    background: #323232 !important;
    color: #fff !important;
    border-radius: 4px !important;
    box-shadow: none !important;
    font-weight: 600 !important;
    font-size: 1rem !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 10px 15px !important;
    border: 1px solid #444 !important;
    text-align: center !important;
  }
  .custom-toast-body {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  max-width: 500px;
  margin: 4rem auto;
  padding: 2rem;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #1f1f21;
  animation: ${fadeIn} 0.5s ease;

  h2 {
    color: #e6e6e6;
    margin-bottom: 1.5rem;
    text-align: center;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #e6e6e6;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #1f1f21;
  background-color: transparent;
  color: #e6e6e6;
  border-radius: 4px;
  text-transform: none;

  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const Button = styled.button`
  background: linear-gradient(90deg, #194bfd 0%, #ad13fb 100%);
  color: #ffffff;
  transition: all 0.3s ease;
  padding: 0.75rem 1.5rem;
  border: none;
  margin-top: 1rem;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  font-weight: bold;

  &:hover {
    background-color: #5a189a;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;

const Footer = styled.div`
  text-align: center;
  margin-top: 1.5rem;
  color: #aaa;

  a {
    color: #4e9eff;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
`;
